import DefaultButton from "@mui/material/Button";
import { SxProps, Theme } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import { MouseEventHandler } from "react";

type IButtonType = "button" | "submit" | "reset" | undefined;

interface IProps {
  btnText: string;
  withIcon?: boolean;
  sx?: SxProps<Theme>;
  colorVariant?: "default" | "primary" | "secondary";
  typeBtn?: IButtonType;
  isDisabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

interface ICustomProps {
  variant?: "text" | "contained" | "outlined";
  btnText: string;
  withIcon?: boolean;
  sx?: SxProps<Theme>;
  colorVariant?: "default" | "primary" | "secondary";
  typeBtn?: IButtonType;
  isDisabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

const getButtonStyles = (colorVariant: "default" | "primary" | "secondary") => {
  switch (colorVariant) {
    case "primary":
      return {
        backgroundColor: "#1FA1E5",
        color: "#FFFFFF",
        "&:hover": {
          backgroundColor: "#65C0F0",
        },
        "&.Mui-disabled": {
          backgroundColor: "#A4BBC740",
          color: "#A4BBC7",
          opacity: 0.9,
        },
      };
    case "secondary":
      return {
        backgroundColor: "#A4BBC7",
        color: "#000000",
        "&:hover": {
          backgroundColor: "#65C0F0",
          color: "#FFFFFF",
        },
        "&.Mui-disabled": {
          backgroundColor: "#A4BBC740",
          color: "#A4BBC7",
          opacity: 0.9,
        },
      };
    default:
      return {
        backgroundColor: "#A4BBC740",
        color: "#000000",
        "&:hover": {
          backgroundColor: "#1FA1E5",
          color: "#FFFFFF",
        },
        "&.Mui-disabled": {
          backgroundColor: "#A4BBC740",
          color: "#A4BBC7",
          opacity: 0.9,
        },
      };
  }
};

const CustomButton = ({
  variant = "contained",
  btnText,
  withIcon = false,
  sx,
  onClick,
  isDisabled,
  colorVariant = "default",
  typeBtn = "button",
}: ICustomProps) => {
  const baseStyles = {
    borderRadius: "10px",
    paddingTop: "15px",
    paddingRight: "30px",
    paddingBottom: "15px",
    paddingLeft: "30px",
    gap: "10px",
    angle: "0 deg",
    opacity: 1,
  };

  const variantStyles = getButtonStyles(colorVariant);

  return (
    <DefaultButton
      variant={variant}
      type={typeBtn}
      disabled={isDisabled}
      onClick={onClick}
      sx={{
        ...baseStyles,
        ...variantStyles,
        ...sx,
      }}
      endIcon={withIcon ? <AddIcon /> : null}
    >
      {btnText}
    </DefaultButton>
  );
};

export const Button = ({
  btnText,
  sx,
  withIcon,
  onClick,
  colorVariant = "default",
  typeBtn = "button",
  isDisabled = false,
}: IProps) => {
  return (
    <CustomButton
      variant="text"
      btnText={btnText}
      withIcon={withIcon}
      sx={sx}
      colorVariant={colorVariant}
      typeBtn={typeBtn}
      isDisabled={isDisabled}
      onClick={onClick}
    />
  );
};
